<template>
    <div class="level">
        <div class="level-item">
            <div class="has-text-centered">
                <b-icon icon="loading"
                        :size="size"
                        custom-class="mdi-spin" />
                <p v-if="text">{{ text }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                required: false,
            },

            size: {
                type: String,
                default: 'is-large',
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/global/components/Loader.vue